import React from "react";

const WFIRSSQuestion5 = ({ questions, renderRadioInputs, questionKey }) => (
  <div key={`WFIRSSQuestion5${questionKey}`}>
    <div className="wfirs-progress-row">
      <div className="wfirs-progress-bar">
        <div style={{ width: "71.4%" }}></div>
      </div>
      <span className="wfirs-counter">5 / 7</span>
    </div>
    <h2 className="wfirs-section-title">Click the number for the rating that best describes how your emotional or behavioral problems have affected your Activities of Daily Living.</h2>
    {questions.slice(41, 46).map((question, index) => (
      <div className="wfirs-question" key={index}>
        <label className="wfirs-q-label">{index + 42}. {question.questions}</label>
        {renderRadioInputs(index + 42)}
      </div>
    ))}
  </div>
);

export default WFIRSSQuestion5;
